import { bodyCopyXSmall } from '@aon/aon-tws-common-ui';
import errorIcon from '@aon/aon-tws-common-ui/build/lib/assets/images/icon-error.svg';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';

/* 
	NOTE: there is a lot more going on in this component than just displaying an error message with the error icon.
			for the standard common design for an error, please use ErrorMessage.
			 
	TODO: This replicates what is in Input.tsx in Common UI. It should be extracted from Input
			 as a stand alone component so it can be used and this can be removed. 
*/

const ErrorContainerWithIcon = styled.div`
	padding: ${globalVars.spacing0} ${globalVars.spacing40} ${globalVars.spacing0} ${globalVars.spacing10};
	border-color: ${globalVars.tertiaryRed};
	background-image: url(${errorIcon});
	background-repeat: no-repeat;
	background-position: 0px 0px;
	background-size: 14px 14px;
	:focus {
		border-color: ${globalVars.tertiaryRed} !important;
		background-image: url(${errorIcon}) !important;
	}
`;

const Message = styled.ul.attrs({
	className: 'error-message',
})`
	margin-top: 0;
	margin-bottom: 0;
	padding: ${globalVars.spacing0};
	padding-left: 12px;
	${bodyCopyXSmall};
	li {
		list-style: none;
	}
`;
Message.displayName = 'Message';
const ErrorMessage = styled(Message)`
	margin-top: 5px;
	margin-bottom: 5px;
	min-height: 20px;
	color: ${globalVars.tertiaryRed};
	line-height: 1.1em;
`;

export interface IErrorBoxProps {
	message: any;
	show: boolean;
}

export class ErrorBoxWithIcon extends React.Component<IErrorBoxProps> {
	constructor(props: IErrorBoxProps) {
		super(props);

		this.getExtraMessage = this.getExtraMessage.bind(this);
	}

	public render() {
		return this.props.show && <ErrorContainerWithIcon>{this.getExtraMessage()}</ErrorContainerWithIcon>;
	}

	private getExtraMessage() {
		const { message } = this.props;
		const messages: string[] = typeof message === 'string' ? [this.props.message] : message;
		const extraMessages = messages.map((m, index) => {
			return (
				<li key={'error-message-' + index}>
					<strong>{ContentConstants.ERROR}: </strong>
					{m}
				</li>
			);
		});
		return <ErrorMessage>{extraMessages}</ErrorMessage>;
	}
}
